"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  COOKIE_TO_HANDLE_DISPLAY: () => COOKIE_TO_HANDLE_DISPLAY,
  Categories: () => Categories,
  CookieBanner: () => CookieBanner,
  CookieManager: () => CookieManager,
  Language: () => Language,
  SegmentCookieManager: () => SegmentCookieManager,
  dispatchedEvents: () => Events,
  isPolicyValid: () => isPolicyValid,
  openCookieBanner: () => openCookieBanner
});
module.exports = __toCommonJS(src_exports);

// src/components/CookieBanner/index.tsx
var import_react7 = __toESM(require("react"));
var import_yoga5 = require("@gympass/yoga");
var import_markdown_to_jsx = __toESM(require("markdown-to-jsx"));

// src/components/CookieManager/index.tsx
var import_react3 = __toESM(require("react"));
var import_yoga3 = require("@gympass/yoga");

// src/types/cookieManager.ts
var Categories = /* @__PURE__ */ ((Categories3) => {
  Categories3[Categories3["analytics"] = 0] = "analytics";
  Categories3[Categories3["essential"] = 1] = "essential";
  Categories3[Categories3["marketing"] = 2] = "marketing";
  Categories3[Categories3["functional"] = 3] = "functional";
  return Categories3;
})(Categories || {});
var Events = /* @__PURE__ */ ((Events2) => {
  Events2["deny_all"] = "@cookie-consent-manager_deny-all";
  Events2["accept_all"] = "@cookie-consent-manager_accept-all";
  Events2["cancel"] = "@cookie-consent-manager_cancel";
  Events2["cookies_settings"] = "@cookie-consent-manager_cookies-settings";
  Events2["save_changes"] = "@cookie-consent-manager_save-changes";
  Events2["toggles"] = "@cookie-consent-manager_toggles";
  Events2["banner_showed"] = "@cookie-consent-manager_banner-showed";
  return Events2;
})(Events || {});

// src/utils/categories.ts
var MARKETING_CATEGORIES = [
  "A/B Testing",
  "Analytics",
  "Attribution",
  "Email",
  "Enrichment",
  "Heatmaps & Recordings",
  "Raw Data",
  "Realtime Dashboards",
  "Referrals",
  "Surveys",
  "Video"
];
var ANALYTICS_CATEGORIES = ["Advertising", "Tag Managers"];
var ESSENTIAL_CATEGORIES = ["Hubspot", "Essential"];
var FUNCTIONAL_CATEGORIES = [
  "CRM",
  "Customer Success",
  "Deep Linking",
  "Helpdesk",
  "Livechat",
  "Performance Monitoring",
  "Personalization",
  "SMS & Push Notifications",
  "Security & Fraud",
  "Functional"
];
function normalizeTools(arr) {
  const normalizedArray = arr.map((item) => {
    if (MARKETING_CATEGORIES.includes(item.category)) {
      return { ...item, category: "marketing" };
    } else if (ANALYTICS_CATEGORIES.includes(item.category)) {
      return { ...item, category: "analytics" };
    } else if (ESSENTIAL_CATEGORIES.includes(item.category)) {
      return { ...item, category: "essential" };
    } else if (FUNCTIONAL_CATEGORIES.includes(item.category)) {
      return { ...item, category: "functional" };
    } else {
      return { ...item, category: "marketing" };
    }
  });
  return normalizedArray;
}
function normalizeDestinations(destinations) {
  const marketing = [];
  const analytics = [];
  const functional = [];
  const essential = [];
  for (const destination of destinations) {
    if (ANALYTICS_CATEGORIES.find((c) => c === destination.category)) {
      analytics.push(destination);
    } else if (FUNCTIONAL_CATEGORIES.find((c) => c === destination.category)) {
      functional.push(destination);
    } else if (ESSENTIAL_CATEGORIES.find((c) => c === destination.category)) {
      essential.push(destination);
    } else {
      marketing.push(destination);
    }
  }
  return {
    marketing,
    analytics,
    functional,
    essential
  };
}

// src/utils/parsers.ts
function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// src/utils/jsonParsers.ts
function extractCategories(cookieValue, language) {
  var _a;
  const categories = (_a = parseJSONString(cookieValue)) == null ? void 0 : _a[language];
  return categories && {
    marketing: categories.marketing,
    analytics: categories.analytics,
    functional: categories.functional,
    essential: true
  };
}
function isValidJSON(str) {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
}
function parseJSONString(JSONString = "{}") {
  try {
    const parsedValue = JSON.parse(JSONString);
    return parsedValue;
  } catch {
    return {};
  }
}

// src/utils/getCurrentDomain.ts
function getCurrentDomain() {
  var _a, _b, _c, _d;
  try {
    return (_d = (_c = (_b = (_a = window == null ? void 0 : window.location) == null ? void 0 : _a.hostname) == null ? void 0 : _b.split(".")) == null ? void 0 : _c.slice(-2)) == null ? void 0 : _d.join(".");
  } catch (error) {
    return "";
  }
}

// src/utils/cookies.ts
var COOKIE_NAME = "gp_consent_privacy";
var COOKIE_TO_HANDLE_DISPLAY = "should_display_cookie_policy";
var COOKIE_DOMAIN = getCurrentDomain();
var COOKIES_ACCEPTANCE = {
  initial: {
    marketing: false,
    analytics: false,
    functional: false,
    essential: true
  },
  positive: {
    marketing: true,
    analytics: true,
    functional: true,
    essential: true
  },
  negative: {
    marketing: false,
    analytics: false,
    functional: false,
    essential: true
  }
};
var addCurrentCountryPropertyToCookieStructure = (country, content, cookieContent = {}) => {
  cookieContent[country] = content;
  return cookieContent;
};
var createCookieStructure = (content, cookieCountry, savedCookie) => {
  const result = savedCookie ? addCurrentCountryPropertyToCookieStructure(cookieCountry, content, parseJSONString(savedCookie)) : addCurrentCountryPropertyToCookieStructure(cookieCountry, content);
  return JSON.stringify(result);
};

// src/components/CookieManager/styles.ts
var import_styled_components = __toESM(require("styled-components"));
var import_yoga = require("@gympass/yoga");
var import_yoga_helpers = require("@gympass/yoga-helpers");
var Container = import_styled_components.default.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;
  padding: 0;
  border-radius: 0;
  overflow: auto;
  background-color: ${import_yoga.theme.colors.white};

  ${import_yoga_helpers.media.lg`
		width: 60%;
		max-width: 880px;
		max-height: calc(100% - 48px);
		border-radius: ${import_yoga.theme.spacing.small}px;
		box-shadow: 0px 8px 20px rgba(152, 152, 166, 0.25);
	`}
`;
var Card = (0, import_styled_components.default)(import_yoga.Card)`
  box-shadow: none;
  padding: 0;
  border-radius: 0;
  padding-bottom: ${import_yoga.theme.spacing.small}px;
  margin-bottom: ${import_yoga.theme.spacing.small}px;

  &:not(:last-child) {
    border-bottom: 1px solid ${import_yoga.theme.colors.light};
  }
`;
var Footer = (0, import_styled_components.default)(import_yoga.Dialog.Footer)`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: ${import_yoga.theme.spacing.xlarge}px;
  margin-top: auto;
  position: sticky;
  bottom: 0;
  z-index: 2;
  width: 100%;
  padding: ${import_yoga.theme.spacing.large}px ${import_yoga.theme.spacing.medium}px;
  box-sizing: border-box;

  background-color: ${import_yoga.theme.colors.white};
  border-top: 1px solid ${import_yoga.theme.colors.light};

  & > div {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: ${import_yoga.theme.spacing.xlarge}px;
  }

  ${import_yoga_helpers.media.md`
		justify-content: space-between;
	`}
`;

// src/translations/content.json
var content_default = {
  "it-it": {
    banner: {
      title: "Utilizziamo i cookie per personalizzare i contenuti e gli annunci pubblicitari, analizzare il traffico e regalarti un'esperienza utente sicura e personalizzata. Per saperne di pi\xF9, leggi la nostra [cookie policy](https://www.gympass.com/en-us/cookies/). Puoi gestire le tue impostazioni qui.",
      preferences: "Cambia preferenze",
      actionButtons: {
        denyAll: "Rifiuta tutto",
        acceptAll: "Accetta tutto"
      }
    },
    manager: {
      title: "Gympass Website Data Collection Preferences",
      description: "Utilizziamo i cookie del browser che sono necessari per far funzionare il sito. Ad esempio, conserviamo le tue preferenze sulla raccolta dei dati in modo da poterle rispettare quando torni sul nostro sito. Puoi disattivare questi cookie dalle impostazioni del browser, ma il sito potrebbe non funzionare correttamente.",
      actionButtons: {
        denyAll: "Rifiuta tutto",
        save: "Salva le modifiche",
        cancel: "Annulla"
      },
      marketing: {
        title: "Marketing",
        type: "marketing",
        description: "Personalizzare e misurare l'efficacia dei messaggi pubblicitari sul nostro e sugli altri siti web. Ad esempio, potremmo proporti una pubblicit\xE0 personalizzata in base alle pagine che visiti sul nostro sito.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Dettagli cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Sempre attivo"
        }
      },
      analytics: {
        title: "Dati di analisi",
        type: "analytics",
        description: "Comprendere il comportamento dell'utente al fine di fornire un'esperienza di navigazione pi\xF9 adeguata o per personalizzare i contenuti del nostro sito. Ad esempio, raccogliamo le informazioni sulle pagine che visiti al fine di proporti informazioni pi\xF9 rilevanti.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Dettagli cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Sempre attivo"
        }
      },
      functional: {
        title: "Funzionali",
        type: "functional",
        description: "Monitorare le prestazioni del nostro sito e migliorare la tua esperienza di navigazione. Ad esempio, questi strumenti ti permettono di comunicare con noi via chat.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Dettagli cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Sempre attivo"
        }
      },
      essential: {
        title: "Necessari",
        type: "essential",
        description: "Utilizziamo i cookie del browser che sono necessari per far funzionare il sito. Ad esempio, conserviamo le tue preferenze sulla raccolta dei dati in modo da poterle rispettare quando torni sul nostro sito. Puoi disattivare questi cookie dalle impostazioni del browser, ma il sito potrebbe non funzionare correttamente.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Dettagli cookie"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Sempre attivo"
        }
      }
    }
  },
  "es-mx": {
    banner: {
      title: "Usamos cookies para personalizar el contenido y los anuncios, analizar el tr\xE1fico de nuestro sitio web y ofrecerte una experiencia de usuario m\xE1s segura. Para m\xE1s informaci\xF3n, puedes consultar nuestra [pol\xEDtica de cookies](https://www.gympass.com/en-us/cookies/). A continuaci\xF3n puedes gestionar tus preferencias de configuraci\xF3n.",
      preferences: "Cambiar preferencias",
      actionButtons: {
        denyAll: "Rechazar todas",
        acceptAll: "Aceptar todas"
      }
    },
    manager: {
      title: "Preferencias de recogida de datos del sitio web de Gympass",
      description: "Usamos los datos y la informaci\xF3n procedentes de las cookies y de JavaScript para mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n, analizar el tr\xE1fico del sitio, mostrar anuncios personalizados y mejorar el funcionamiento en general de nuestro sitio web. ",
      actionButtons: {
        denyAll: "Rechazar todas",
        save: "Guardar cambios",
        cancel: "Cancelar"
      },
      marketing: {
        title: "De marketing",
        type: "marketing",
        description: "Personalizar y medir la efectividad de la publicidad que aparece en nuestro sitio web y en el de otros. Por ejemplo, podemos mostrarte un anuncio personalizado bas\xE1ndonos en las p\xE1ginas de nuestro sitio web que visites.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      analytics: {
        title: "Anal\xEDticas",
        type: "analytics",
        description: "Entender el comportamiento del usuario con el fin de ofrecer una experiencia m\xE1s relevante en la b\xFAsqueda de informaci\xF3n o personalizar el contenido de nuestro sitio. Por ejemplo, recogemos informaci\xF3n sobre las p\xE1ginas que visitas para que esto nos ayude a proporcionar informaci\xF3n que sea m\xE1s relevante.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      functional: {
        title: "De funcionalidad",
        type: "functional",
        description: "Controlar el funcionamiento de nuestro sitio web y mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n. Por ejemplo, estas herramientas hacen posible que puedas comunicarte con nosotros a trav\xE9s del chat en directo. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      essential: {
        title: "Estrictamente necesarias",
        type: "essential",
        description: "Usamos las cookies de b\xFAsqueda que son estrictamente necesarias para que el sitio funcione correctamente. Por ejemplo, almacenaremos tus preferencias de recogida de datos de nuestro sitio web para respetarlas cada vez que regreses al mismo. Puedes deshabilitar estas cookies en las preferencias de tu buscador, pero si haces esto puede que el sitio web no funcione correctamente. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Siempre activa"
        }
      }
    }
  },
  "es-es": {
    banner: {
      title: "Usamos cookies para personalizar el contenido y los anuncios, analizar el tr\xE1fico de nuestro sitio web y ofrecerte una experiencia de usuario m\xE1s segura. Para m\xE1s informaci\xF3n, puedes consultar nuestra [pol\xEDtica de cookies](https://www.gympass.com/en-us/cookies/). A continuaci\xF3n puedes gestionar tus preferencias de configuraci\xF3n.",
      preferences: "Cambiar preferencias",
      actionButtons: {
        denyAll: "Rechazar todas",
        acceptAll: "Aceptar todas"
      }
    },
    manager: {
      title: "Preferencias de recogida de datos del sitio web de Gympass",
      description: "Usamos los datos y la informaci\xF3n procedentes de las cookies y de JavaScript para mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n, analizar el tr\xE1fico del sitio, mostrar anuncios personalizados y mejorar el funcionamiento en general de nuestro sitio web. ",
      actionButtons: {
        denyAll: "Rechazar todas",
        save: "Guardar cambios",
        cancel: "Cancelar"
      },
      marketing: {
        title: "De marketing",
        type: "marketing",
        description: "Personalizar y medir la efectividad de la publicidad que aparece en nuestro sitio web y en el de otros. Por ejemplo, podemos mostrarte un anuncio personalizado bas\xE1ndonos en las p\xE1ginas de nuestro sitio web que visites.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      analytics: {
        title: "Anal\xEDticas",
        type: "analytics",
        description: "Entender el comportamiento del usuario con el fin de ofrecer una experiencia m\xE1s relevante en la b\xFAsqueda de informaci\xF3n o personalizar el contenido de nuestro sitio. Por ejemplo, recogemos informaci\xF3n sobre las p\xE1ginas que visitas para que esto nos ayude a proporcionar informaci\xF3n que sea m\xE1s relevante.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      functional: {
        title: "De funcionalidad",
        type: "functional",
        description: "Controlar el funcionamiento de nuestro sitio web y mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n. Por ejemplo, estas herramientas hacen posible que puedas comunicarte con nosotros a trav\xE9s del chat en directo. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      essential: {
        title: "Estrictamente necesarias",
        type: "essential",
        description: "Usamos las cookies de b\xFAsqueda que son estrictamente necesarias para que el sitio funcione correctamente. Por ejemplo, almacenaremos tus preferencias de recogida de datos de nuestro sitio web para respetarlas cada vez que regreses al mismo. Puedes deshabilitar estas cookies en las preferencias de tu buscador, pero si haces esto puede que el sitio web no funcione correctamente. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Siempre activa"
        }
      }
    }
  },
  "es-ar": {
    banner: {
      title: "Usamos cookies para personalizar el contenido y los anuncios, analizar el tr\xE1fico de nuestro sitio web y ofrecerte una experiencia de usuario m\xE1s segura. Para m\xE1s informaci\xF3n, pod\xE9s consultar nuestra [pol\xEDtica de cookies](https://www.gympass.com/en-us/cookies/). A continuaci\xF3n pod\xE9s gestionar tus preferencias de configuraci\xF3n.",
      preferences: "Cambiar preferencias",
      actionButtons: {
        denyAll: "Rechazar todas",
        acceptAll: "Aceptar todas"
      }
    },
    manager: {
      title: "Preferencias de recogida de datos del sitio web de Gympass",
      description: "Usamos los datos y la informaci\xF3n procedentes de las cookies y de JavaScript para mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n, analizar el tr\xE1fico del sitio, mostrar anuncios personalizados y mejorar el funcionamiento en general de nuestro sitio web. ",
      actionButtons: {
        denyAll: "Rechazar todas",
        save: "Guardar cambios",
        cancel: "Cancelar"
      },
      marketing: {
        title: "De marketing",
        type: "marketing",
        description: "Personalizar y medir la efectividad de la publicidad que aparece en nuestro sitio web y en el de otros. Por ejemplo, podemos mostrarte un anuncio personalizado bas\xE1ndonos en las p\xE1ginas de nuestro sitio web que visites.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      analytics: {
        title: "Anal\xEDticas",
        type: "analytics",
        description: "Entender el comportamiento del usuario con el fin de ofrecer una experiencia m\xE1s relevante en la b\xFAsqueda de informaci\xF3n o personalizar el contenido de nuestro sitio. Por ejemplo, recogemos informaci\xF3n sobre las p\xE1ginas que visit\xE1s para que esto nos ayude a proporcionar informaci\xF3n que sea m\xE1s relevante.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      functional: {
        title: "De funcionalidad",
        type: "functional",
        description: "Controlar el funcionamiento de nuestro sitio web y mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n. Por ejemplo, estas herramientas hacen posible que pod\xE1s comunicarte con nosotros a trav\xE9s del chat en directo. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      essential: {
        title: "Estrictamente necesarias",
        type: "essential",
        description: "Usamos las cookies de b\xFAsqueda que son estrictamente necesarias para que el sitio funcione correctamente. Por ejemplo, almacenaremos tus preferencias de recogida de datos de nuestro sitio web para respetarlas cada vez que regreses al mismo. Pod\xE9s deshabilitar estas cookies en las preferencias de tu buscador, pero si hac\xE9s esto puede que el sitio web no funcione correctamente. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Siempre activa"
        }
      }
    }
  },
  "es-cl": {
    banner: {
      title: "Usamos cookies para personalizar el contenido y los anuncios, analizar el tr\xE1fico de nuestro sitio web y ofrecerte una experiencia de usuario m\xE1s segura. Para m\xE1s informaci\xF3n, puedes consultar nuestra [pol\xEDtica de cookies](https://www.gympass.com/en-us/cookies/). A continuaci\xF3n puedes gestionar tus preferencias de configuraci\xF3n.",
      preferences: "Cambiar preferencias",
      actionButtons: {
        denyAll: "Rechazar todas",
        acceptAll: "Aceptar todas"
      }
    },
    manager: {
      title: "Preferencias de recogida de datos del sitio web de Gympass",
      description: "Usamos los datos y la informaci\xF3n procedentes de las cookies y de JavaScript para mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n, analizar el tr\xE1fico del sitio, mostrar anuncios personalizados y mejorar el funcionamiento en general de nuestro sitio web. ",
      actionButtons: {
        denyAll: "Rechazar todas",
        save: "Guardar cambios",
        cancel: "Cancelar"
      },
      marketing: {
        title: "De marketing",
        type: "marketing",
        description: "Personalizar y medir la efectividad de la publicidad que aparece en nuestro sitio web y en el de otros. Por ejemplo, podemos mostrarte un anuncio personalizado bas\xE1ndonos en las p\xE1ginas de nuestro sitio web que visites.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      analytics: {
        title: "Anal\xEDticas",
        type: "analytics",
        description: "Entender el comportamiento del usuario con el fin de ofrecer una experiencia m\xE1s relevante en la b\xFAsqueda de informaci\xF3n o personalizar el contenido de nuestro sitio. Por ejemplo, recogemos informaci\xF3n sobre las p\xE1ginas que visitas para que esto nos ayude a proporcionar informaci\xF3n que sea m\xE1s relevante.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      functional: {
        title: "De funcionalidad",
        type: "functional",
        description: "Controlar el funcionamiento de nuestro sitio web y mejorar tu experiencia en la b\xFAsqueda de informaci\xF3n. Por ejemplo, estas herramientas hacen posible que puedas comunicarte con nosotros a trav\xE9s del chat en directo. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Siempre activa"
        }
      },
      essential: {
        title: "Estrictamente necesarias",
        type: "essential",
        description: "Usamos las cookies de b\xFAsqueda que son estrictamente necesarias para que el sitio funcione correctamente. Por ejemplo, almacenaremos tus preferencias de recogida de datos de nuestro sitio web para respetarlas cada vez que regreses al mismo. Puedes deshabilitar estas cookies en las preferencias de tu buscador, pero si haces esto puede que el sitio web no funcione correctamente. ",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "M\xE1s informaci\xF3n sobre la cookie"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Siempre activa"
        }
      }
    }
  },
  "de-de": {
    banner: {
      title: "Wir verwenden Cookies, um Inhalte und Anzeigen zu personalisieren, den Datenverkehr zu analysieren und um ein sichereres Nutzererlebnis zu bieten. Siehe unsere [cookie-richtlinie](https://www.gympass.com/en-us/cookies/) f\xFCr weitere Informationen.",
      preferences: "Pr\xE4ferenzen \xE4ndern",
      actionButtons: {
        denyAll: "Alle ablehnen",
        acceptAll: "Alle akzeptieren"
      }
    },
    manager: {
      title: "Pr\xE4ferenzen f\xFCr die Datenerfassung auf der Gympass-Website",
      description: "Wir verwenden die von Cookies und JavaScript-Bibliotheken gesammelten Daten, um das Surferlebnis zu verbessern, den Website-Verkehr zu analysieren, personalisierte Werbung anzuzeigen und die Gesamtleistung unserer Website zu verbessern.",
      actionButtons: {
        denyAll: "Alle ablehnen",
        save: "\xC4nderungen speichern",
        cancel: "Abbrechen"
      },
      marketing: {
        title: "Marketing",
        type: "marketing",
        description: "Zur Personalisierung und Messung der Wirksamkeit von Werbung auf unserer und anderen Websites. Wir k\xF6nnen zum Beispiel personalisierte Werbung basierend auf den Seiten, die auf unserer Website besucht werden, anzeigen.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie-Details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Immer aktiv"
        }
      },
      analytics: {
        title: "Analyse",
        type: "analytics",
        description: "Um das Nutzungsverhalten zu verstehen, damit wir ein relevanteres Surferlebnis bieten oder den Inhalt unserer Website personalisieren k\xF6nnen. Wir sammeln zum Beispiel Informationen dar\xFCber, welche Seiten besucht werden, um relevantere Informationen anzeigen zu k\xF6nnen.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie-Details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Immer aktiv"
        }
      },
      functional: {
        title: "Funktional",
        type: "functional",
        description: "Zur \xDCberwachung der Leistung unserer Website und zur Verbesserung des Surferlebnisses. Diese Tools erm\xF6glichen es zum Beispiel, mit uns \xFCber einen Live-Chat zu kommunizieren.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie-Details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Immer aktiv"
        }
      },
      essential: {
        title: "Notwendige",
        type: "essential",
        description: "Wir verwenden Browser-Cookies, die notwendig sind, damit die Website wie vorgesehen funktioniert. So speichern wir zum Beispiel Pr\xE4ferenzen f\xFCr die Datenerfassung auf der Website, damit wir sie ber\xFCcksichtigen k\xF6nnen, wenn die Nutzer:innen auf unsere Website zur\xFCckkehren. Diese Cookies k\xF6nnen in den Browsereinstellungen deaktiviert werden, jedoch funktioniert die Website dann m\xF6glicherweise nicht wie vorgesehen.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie-Details"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Immer aktiv"
        }
      }
    }
  },
  "en-uk": {
    banner: {
      title: "We use cookies to personalise content and ads, analyse traffic, and provide you with a safer user experience. See our [cookies policy](https://www.gympass.com/en-us/cookies/) for more information. You can manage your settings here.",
      preferences: "Change Preferences",
      actionButtons: {
        denyAll: "Deny all",
        acceptAll: "Accept all"
      }
    },
    manager: {
      title: "Gympass Website Data Collection Preferences",
      description: "We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.",
      actionButtons: {
        denyAll: "Deny all",
        save: "Save changes",
        cancel: "Cancel"
      },
      marketing: {
        title: "Marketing",
        type: "marketing",
        description: "To personalise and measure the effectiveness of advertising on our site and other websites. For example, we may serve you a personalised ad based on the pages you visit on our site.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      analytics: {
        title: "Analytics",
        type: "analytics",
        description: "To understand user behaviour in order to provide you with a more relevant browsing experience or personalise the content on our site. For example, we collect information about which pages you visit to help us present more relevant information.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      functional: {
        title: "Functional",
        type: "functional",
        description: "To monitor the performance of our site and to enhance your browsing experience. For example, these tools enable you to communicate with us via live chat.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      essential: {
        title: "Essential",
        type: "essential",
        description: "We use browser cookies that are necessary for the site to work as intended. For example, we store your website data collection preferences, so we can honour them if you return to our site. You can disable these cookies in your browser settings, but if you do so the site may not work as intended.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Always active"
        }
      }
    }
  },
  "en-ie": {
    banner: {
      title: "We use cookies to personalise content and ads, analyse traffic, and provide you with a safer user experience. See our [cookies policy](https://www.gympass.com/en-us/cookies/) for more information. You can manage your settings here.",
      preferences: "Change Preferences",
      actionButtons: {
        denyAll: "Deny all",
        acceptAll: "Accept all"
      }
    },
    manager: {
      title: "Gympass Website Data Collection Preferences",
      description: "We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.",
      actionButtons: {
        denyAll: "Deny All",
        save: "Save changes",
        cancel: "Cancel"
      },
      marketing: {
        title: "Marketing",
        type: "marketing",
        description: "To personalise and measure the effectiveness of advertising on our site and other websites. For example, we may serve you a personalised ad based on the pages you visit on our site.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      analytics: {
        title: "Analytics",
        type: "analytics",
        description: "To understand user behaviour in order to provide you with a more relevant browsing experience or personalise the content on our site. For example, we collect information about which pages you visit to help us present more relevant information.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      functional: {
        title: "Functional",
        type: "functional",
        description: "To monitor the performance of our site and to enhance your browsing experience. For example, these tools enable you to communicate with us via live chat.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      essential: {
        title: "Essential",
        type: "essential",
        description: "We use browser cookies that are necessary for the site to work as intended. For example, we store your website data collection preferences, so we can honour them if you return to our site. You can disable these cookies in your browser settings, but if you do so the site may not work as intended.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookie details"
        },
        checked: false,
        alwaysActive: {
          value: true,
          label: "Always active"
        }
      }
    }
  },
  "en-us": {
    banner: {
      title: "We use cookies to personalize content and ads, to analyze traffic, and to provide you with a safer user experience. See our [cookies policy](https://www.gympass.com/en-us/cookies/)  for more information. You can manage your settings here.",
      preferences: "Change Preferences",
      actionButtons: {
        denyAll: "Deny All",
        acceptAll: "Accept All"
      }
    },
    manager: {
      title: "Gympass Website Data Collection Preferences",
      description: "We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, deliver personalized advertisements, and increase the overall performance of our site.",
      actionButtons: {
        denyAll: "Deny All",
        save: "Save changes",
        cancel: "Cancel"
      },
      marketing: {
        title: "Marketing",
        type: "marketing",
        description: "To personalize and measure the effectiveness of advertising on our site and other websites. For example, we may serve you a personalized ad based on the pages you visit on our site.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookies details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      analytics: {
        title: "Analytics",
        type: "analytics",
        description: "To understand user behavior in order to provide you with a more relevant browsing experience or personalize the content on our site. For example, we collect information about which pages you visit to help us present more relevant information",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookies details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      functional: {
        title: "Functional",
        type: "functional",
        description: "To monitor the performance of our site and to enhance your browsing experience. For example, these tools enable you to communicate with us via live chat.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookies details"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Always active"
        }
      },
      essential: {
        title: "Essential",
        type: "essential",
        description: "We use browser cookies that are necessary for the site to work as intended. For example, we store your website data collection preferences so we can honor them if you return to our site. You can disable these cookies in your browser settings but if you do the site may not work as intended.",
        details: {
          link: "http://www.gympass.com/en-us/cookies/",
          label: "Cookies details"
        },
        checked: true,
        alwaysActive: {
          value: true,
          label: "Always active"
        }
      }
    }
  },
  "pt-br": {
    banner: {
      title: "Usamos cookies para personalizar conte\xFAdos e an\xFAncios para voc\xEA, para an\xE1lise de tr\xE1fego e para sua seguran\xE7a. Leia nossa [pol\xEDtica de cookies](https://www.gympass.com/en-us/cookies/) para mais informa\xE7\xF5es. Voc\xEA pode alterar suas configura\xE7\xF5es aqui.",
      preferences: "Mudar prefer\xEAncias",
      actionButtons: {
        denyAll: "Recusar todos",
        acceptAll: "Aceitar todos"
      }
    },
    manager: {
      title: "Prefer\xEAncias de coleta de dados no site do Gympass",
      description: "N\xF3s utilizamos os dados coletados por cookies e bibliotecas JavaScript para aprimorar sua experi\xEAncia de navega\xE7\xE3o, analisar o tr\xE1fego do site, apresentar an\xFAncios personalizados e melhorar o desempenho geral do nosso site.",
      actionButtons: {
        denyAll: "Recusar todos",
        save: "Salvar altera\xE7\xF5es",
        cancel: "Cancelar"
      },
      marketing: {
        title: "Marketing",
        type: "marketing",
        description: "Personalizar e mensurar a efic\xE1cia dos an\xFAncios em nosso site e em outros sites. Por exemplo, podemos apresentar um an\xFAncio personalizado com base nas p\xE1ginas que voc\xEA visita no nosso site.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Informa\xE7\xF5es sobre os cookies"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Sempre ativo"
        }
      },
      analytics: {
        title: "An\xE1lise de dados",
        type: "analytics",
        description: "Compreender o comportamento do usu\xE1rio para proporcionar uma experi\xEAncia de navega\xE7\xE3o mais relevante ou personalizar o conte\xFAdo do site. Por exemplo, coletamos informa\xE7\xF5es sobre quais p\xE1ginas voc\xEA visita para nos ajudar a apresentar informa\xE7\xF5es mais relevantes para voc\xEA.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Informa\xE7\xF5es sobre os cookies"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Sempre ativo"
        }
      },
      functional: {
        title: "Funcional",
        type: "functional",
        description: "Monitorar o desempenho do nosso site e aprimorar sua experi\xEAncia de navega\xE7\xE3o. Por exemplo, essas ferramentas permitem que voc\xEA se comunique conosco atrav\xE9s do chat.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Informa\xE7\xF5es sobre os cookies"
        },
        checked: false,
        alwaysActive: {
          value: false,
          label: "Sempre ativo"
        }
      },
      essential: {
        title: "Essenciais",
        type: "essential",
        description: "Utilizamos cookies de navega\xE7\xE3o necess\xE1rios para o funcionamento adequado do site. Por exemplo, n\xF3s armazenamos suas prefer\xEAncias de coleta de dados em nosso site para que possamos honr\xE1-las se voc\xEA voltar ao nosso site. Esses cookies podem ser desabilitados nas configura\xE7\xF5es do seu navegador, por\xE9m o site pode n\xE3o funcionar da forma correta.",
        details: {
          link: "https://www.gympass.com/en-us/cookies/",
          label: "Informa\xE7\xF5es sobre os cookies"
        },
        checked: true,
        alwaysActive: {
          value: true,
          label: "Sempre ativo"
        }
      }
    }
  }
};

// src/components/FullPageModal/index.tsx
var import_react = __toESM(require("react"));

// src/components/FullPageModal/styles.ts
var import_styled_components2 = __toESM(require("styled-components"));
var Container2 = import_styled_components2.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  overflow: auto;
  width: 100vw;
  height: 100vh;
  top: 0;
  background-color: rgba(35, 27, 34, 0.48);
  z-index: 99999999;
  animation-name: bounceIn;
  animation-duration: 0.5s;
  animation-fill-mode: both;
`;

// src/components/FullPageModal/index.tsx
function FullPageModal({ children, isOpen, id, ariaLabelledBy }) {
  if (!isOpen)
    return null;
  return /* @__PURE__ */ import_react.default.createElement(Container2, { isOpen, id, tabIndex: -1, "aria-labelledby": ariaLabelledBy, "aria-hidden": true }, children);
}

// src/components/Link/index.tsx
var import_react2 = __toESM(require("react"));

// src/components/Link/styles.ts
var import_styled_components3 = __toESM(require("styled-components"));
var import_yoga2 = require("@gympass/yoga");
var Link = (0, import_styled_components3.default)(import_yoga2.Button.Link)`
  background: transparent;
  color: rgb(216, 56, 94);
  height: auto;
  outline: none;
  padding: 0px;
  text-align: left;
  text-decorator: underline;

  :hover,
  :focus {
    box-shadow: none !important;
    color: rgba(216, 56, 94, 0.75);
  }

  button {
    background: transparent;
    color: rgb(216, 56, 94);
    height: auto;
    outline: none;
    padding: 0px;
    text-align: left;
    text-decorator: underline;

    :hover,
    :focus {
      box-shadow: none !important;
      color: rgba(216, 56, 94, 0.75);
    }
  }
`;

// src/components/Link/index.tsx
function LinkComponent(props) {
  return /* @__PURE__ */ import_react2.default.createElement(Link, { ...props });
}

// src/components/CookieManager/index.tsx
var toggleReducer = (state, action) => {
  switch (action.type) {
    case "TOGGLE":
      return {
        ...state,
        [action.payload.name]: !state[action.payload.name]
      };
    case "UPDATE":
      return {
        ...state,
        [action.payload.name]: action.payload.value
      };
    default:
      return state;
  }
};
function CookieManager({
  handleOnClose,
  handleOnDenyAll,
  handleOnSubmit,
  isModalOpen,
  language,
  preferencesCookie = {},
  toolsList
}) {
  var _a, _b, _c, _d;
  const [state, dispatch] = (0, import_react3.useReducer)(toggleReducer, preferencesCookie);
  const normalizedCategories = Object.entries(normalizeDestinations(toolsList));
  const cookieManagerContent = (_a = content_default[language]) == null ? void 0 : _a.manager;
  (0, import_react3.useEffect)(() => {
    if (preferencesCookie) {
      Object.entries(preferencesCookie).forEach(([key, value]) => {
        dispatch({
          type: "UPDATE" /* UPDATE */,
          payload: {
            name: key,
            value
          }
        });
      });
    }
  }, [preferencesCookie]);
  return /* @__PURE__ */ import_react3.default.createElement(FullPageModal, { isOpen: isModalOpen, id: "cookieModal", ariaLabelledBy: "cookieModal" }, /* @__PURE__ */ import_react3.default.createElement(Container, null, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Dialog.Header, { mb: 0, style: { textAlign: "left", width: "100%" } }, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Text.H5, { px: 20, pt: 24, pb: 16, color: "stamina", style: { textAlign: "left" } }, cookieManagerContent.title)), /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Dialog.Content, { px: 20 }, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Text, { color: "deep", style: { textAlign: "left" } }, cookieManagerContent.description), /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Box, { display: "flex", flexDirection: "column", width: "100%", mt: 16 }, normalizedCategories.map((item) => {
    var _a2, _b2, _c2, _d2;
    const cookieKey = item[0];
    const categoryContent = cookieManagerContent[cookieKey];
    return /* @__PURE__ */ import_react3.default.createElement(Card, { key: cookieKey }, /* @__PURE__ */ import_react3.default.createElement(Card.Header, { d: "flex", alignItems: "center", justifyContent: "space-between" }, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Text.Medium, null, capitalizeFirstLetter((categoryContent == null ? void 0 : categoryContent.title) || cookieKey)), ((_a2 = categoryContent == null ? void 0 : categoryContent.alwaysActive) == null ? void 0 : _a2.value) ? /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Text.Bold, { color: "vibin" }, (_b2 = categoryContent == null ? void 0 : categoryContent.alwaysActive) == null ? void 0 : _b2.label) : /* @__PURE__ */ import_react3.default.createElement(
      import_yoga3.Checkbox.Switch,
      {
        checked: state[cookieKey] ? true : false,
        onChange: () => {
          document.dispatchEvent(new CustomEvent("@cookie-consent-manager_toggles" /* toggles */, { detail: { toggle: cookieKey } }));
          dispatch({
            type: "TOGGLE" /* TOGGLE */,
            payload: {
              name: item[0],
              value: state[cookieKey]
            }
          });
        }
      }
    )), /* @__PURE__ */ import_react3.default.createElement(Card.Content, null, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Box, { mt: "small", p: 0 }, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Text.Small, { p: 0, color: "deep", style: { textAlign: "left" } }, categoryContent == null ? void 0 : categoryContent.description))), /* @__PURE__ */ import_react3.default.createElement(Card.Actions, null, (categoryContent == null ? void 0 : categoryContent.details) && /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Box, { display: "flex", justifyContent: "flex-start", width: "100%", my: 12 }, /* @__PURE__ */ import_react3.default.createElement(
      LinkComponent,
      {
        href: (_c2 = categoryContent == null ? void 0 : categoryContent.details) == null ? void 0 : _c2.link,
        target: "blank",
        style: {
          textAlign: "left",
          textDecoration: "underline"
        }
      },
      (_d2 = categoryContent == null ? void 0 : categoryContent.details) == null ? void 0 : _d2.label
    ))));
  }))), /* @__PURE__ */ import_react3.default.createElement(Footer, null, /* @__PURE__ */ import_react3.default.createElement(LinkComponent, { style: { textDecoration: "underline" }, small: true, onClick: () => handleOnDenyAll() }, (_b = cookieManagerContent == null ? void 0 : cookieManagerContent.actionButtons) == null ? void 0 : _b.denyAll), /* @__PURE__ */ import_react3.default.createElement("div", null, /* @__PURE__ */ import_react3.default.createElement(import_yoga3.Button.Outline, { small: true, onClick: () => handleOnClose() }, (_c = cookieManagerContent == null ? void 0 : cookieManagerContent.actionButtons) == null ? void 0 : _c.cancel), /* @__PURE__ */ import_react3.default.createElement(
    import_yoga3.Button,
    {
      small: true,
      style: { minWidth: "126px" },
      onClick: () => {
        handleOnSubmit({ ...COOKIES_ACCEPTANCE.initial, ...state });
      }
    },
    (_d = cookieManagerContent == null ? void 0 : cookieManagerContent.actionButtons) == null ? void 0 : _d.save
  )))));
}

// src/components/CookieBanner/index.tsx
var import_lodash = __toESM(require("lodash"));

// src/hooks/useCookie/useCookie.tsx
var import_react4 = require("react");
var import_js_cookie = __toESM(require("js-cookie"));
function useCookie() {
  const setCookie = (0, import_react4.useCallback)(
    ({
      cookieName = "",
      cookieValue = "",
      cookiePath,
      cookieDaysToExpires = 360,
      cookieDomain = ".gympass.com"
    }) => {
      const expirationDate = new Date((/* @__PURE__ */ new Date()).setDate((/* @__PURE__ */ new Date()).getDate() + cookieDaysToExpires));
      import_js_cookie.default.set(cookieName, cookieValue, {
        path: cookiePath || "/",
        expires: expirationDate,
        domain: cookieDomain
      });
    },
    []
  );
  const removeCookies = (0, import_react4.useCallback)((cookies) => {
    cookies.forEach((cookieName) => import_js_cookie.default.remove(cookieName));
  }, []);
  const getCookies = (0, import_react4.useCallback)((cookies) => {
    return cookies.map((cookieName) => import_js_cookie.default.get(cookieName) || "");
  }, []);
  const listenToCookie = (cookieName, callback, timeout = 5e3, intervalTimer = 500) => {
    const TIMEOUT = timeout || 5e3;
    const INTERVAL_TIMER = intervalTimer || 500;
    let currentTimer = 0;
    const intervalCheck = function() {
      currentTimer += INTERVAL_TIMER;
      const cookie = import_js_cookie.default.get(cookieName);
      if (cookie) {
        clearInterval(verifyCookieInterval);
        if (callback)
          callback(cookie);
        return cookie;
      }
      if (currentTimer >= TIMEOUT) {
        clearInterval(verifyCookieInterval);
        return;
      }
    };
    const verifyCookieInterval = setInterval(intervalCheck, INTERVAL_TIMER);
  };
  return (0, import_react4.useMemo)(
    () => ({
      getCookies,
      setCookie,
      removeCookies,
      listenToCookie
    }),
    [getCookies, setCookie, removeCookies]
  );
}

// src/components/CookieBanner/styles.ts
var import_styled_components4 = __toESM(require("styled-components"));
var import_yoga4 = require("@gympass/yoga");
var import_yoga_helpers2 = require("@gympass/yoga-helpers");
var Container3 = (0, import_styled_components4.default)(import_yoga4.Card)`
  position: fixed;
  margin: ${import_yoga4.theme.spacing.large}px ${import_yoga4.theme.spacing.medium}px;
  padding: 0;
  bottom: 0;
  z-index: 99;

  a {
    color: ${import_yoga4.theme.colors.vibin};
    font-size: ${import_yoga4.theme.fontSizes.medium}px;
    text-decoration-line: underline;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
    &:focus {
      color: ${import_yoga4.theme.colors.vibin}75;
    }
  }

  ${import_yoga_helpers2.media.lg`
		width: 55%;
		max-width: 840px;
		left: 50%;
		transform: translateX(-50%);
	`}
`;
var Actions = (0, import_styled_components4.default)(import_yoga4.Card.Actions)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: ${import_yoga4.theme.spacing.large}px;
  gap: ${import_yoga4.theme.spacing.large}px;
  border-top: 1px solid ${import_yoga4.theme.colors.light};

  ${import_yoga_helpers2.media.lg`
		justify-content: space-between;
	`}
`;

// src/utils/toolsList.ts
var listOfTools = [
  {
    name: "Amplitude (Actions) Mock",
    id: "Actions Amplitude",
    description: "Amplitude is an event tracking and segmentation platform for your web and mobile apps. By analyzing the actions your users perform, you can gain a better understanding to drive retention, engagement, and conversion.",
    website: "https://amplitude.com",
    category: "Analytics"
  },
  {
    name: "Google Tag Manager Mock",
    id: "Google Tag Manager",
    description: "Google Tag Manager lets you add or update your website tags, easily and for free.",
    website: "https://www.google.com/analytics/tag-manager/",
    category: "Tag Managers"
  },
  {
    name: "Optimizely Web Mock",
    id: "Optimizely",
    description: "Optimizely is a dead-simple A/B testing tool that lets your marketing team test changes on your website in a WYSIWYG editor without having to write any code. Segment will pass events and traits to Optimizely, and send experiment variations to other tools.",
    website: "http://optimizely.com",
    category: "A/B Testing"
  },
  {
    name: "Amplitude Mock",
    id: "Amplitude",
    description: "Amplitude is an event tracking and segmentation platform for your web and mobile apps. By analyzing the actions your users perform, you can gain a better understanding to drive retention, engagement, and conversion.",
    website: "http://amplitude.com",
    category: "Analytics"
  },
  {
    name: "Hubspot Form Destination Track V2 (Gympass [Martech]) Mock",
    id: "Hubspot Form Destination Track V2 (Gympass [Martech])",
    description: "This destination sent events of Form Submitted to Hubspot when you send a track to the Segment. You will need to create the form on Hubspot before use this Destination.\n\nThe V2 includes the new authorization demanded by Hubspot called private app key",
    website: "https://www.segment.com",
    category: "Other"
  }
];

// src/components/CookieBanner/utils/updateCookieDisplay.tsx
function updateCookieToHandleDisplay(setCookie, policyVersion, language, firstInteractionCookie, onUserConsentOrDeny) {
  const interactionCookie = { policyVersion };
  const cookieByCountry = createCookieStructure(interactionCookie, language, firstInteractionCookie);
  setCookie({
    cookieName: COOKIE_TO_HANDLE_DISPLAY,
    cookieValue: cookieByCountry,
    cookieDomain: COOKIE_DOMAIN
  });
  onUserConsentOrDeny && onUserConsentOrDeny();
}

// src/utils/events.ts
var COOKIE_CONSENT_OPEN_BANNER_NAME = "open_cookie_consent_banner";
var eventOpenCookieConsentBanner = () => new CustomEvent(COOKIE_CONSENT_OPEN_BANNER_NAME);

// src/utils/policyVersion.ts
var import_js_cookie2 = __toESM(require("js-cookie"));
function isPolicyValid(language, policyVersion) {
  var _a;
  if (!(language && policyVersion))
    return;
  const cookieString = import_js_cookie2.default.get(COOKIE_TO_HANDLE_DISPLAY);
  const cookieValue = parseJSONString(cookieString);
  return ((_a = cookieValue == null ? void 0 : cookieValue[language]) == null ? void 0 : _a.policyVersion) === policyVersion;
}

// src/hooks/useDocumentListener/index.ts
var import_react5 = require("react");
function useDocumentListener(eventName, callback) {
  (0, import_react5.useEffect)(() => {
    document.addEventListener(eventName, callback);
    return () => {
      document.removeEventListener(eventName, callback);
    };
  }, []);
}

// src/hooks/useInitialCategories/index.ts
var import_react6 = require("react");
function useInitialCategories(forceInitialCategories, currentCategories, saveCookie, initialCategories) {
  (0, import_react6.useEffect)(() => {
    if (!initialCategories)
      return;
    if (forceInitialCategories || !currentCategories) {
      saveCookie({ ...COOKIES_ACCEPTANCE.negative, ...initialCategories }, true);
      return;
    }
  }, []);
}

// src/components/CookieBanner/index.tsx
function openCookieBanner() {
  document.dispatchEvent(eventOpenCookieConsentBanner());
}
function CookieBanner({
  toolsList = listOfTools,
  onUserConsentOrDeny,
  onCookieUpdate,
  language = "en-us",
  policyVersion = "1.0.0",
  initialCategories,
  forceInitialCategories = false,
  optInLayoutVersion = false
}) {
  var _a;
  const { getCookies, setCookie } = useCookie();
  const [isModalOpen, setIsModalOpen] = (0, import_react7.useState)(false);
  const [shouldRender, setShouldRender] = (0, import_react7.useState)(false);
  const [preferencesCookie, setPreferencesCookie] = (0, import_react7.useState)(COOKIES_ACCEPTANCE.initial);
  const [firstPreferenceCookie, firstInteractionCookie] = getCookies([COOKIE_NAME, COOKIE_TO_HANDLE_DISPLAY]);
  const currentPreferences = (0, import_react7.useMemo)(() => {
    if (!isValidJSON(firstPreferenceCookie))
      return;
    return extractCategories(firstPreferenceCookie, language);
  }, [firstPreferenceCookie, language]);
  const cookieBannerContent = (_a = content_default[language]) == null ? void 0 : _a.banner;
  const setCookieManagerState = () => {
    document.dispatchEvent(new Event("@cookie-consent-manager_banner-showed" /* banner_showed */));
    setShouldRender(true);
  };
  useDocumentListener(COOKIE_CONSENT_OPEN_BANNER_NAME, setCookieManagerState);
  (0, import_react7.useEffect)(() => {
    const policyIsValid = isPolicyValid(language, policyVersion);
    if (firstInteractionCookie && policyIsValid) {
      setShouldRender(false);
    } else {
      setCookieManagerState();
    }
  }, []);
  const saveCookie = (categories, saveStartedOnUseEffect) => {
    if (!saveStartedOnUseEffect) {
      updateCookieToHandleDisplay(setCookie, policyVersion, language, firstInteractionCookie);
      onUserConsentOrDeny && onUserConsentOrDeny(categories);
      setShouldRender(false);
    }
    setPreferencesCookie(categories);
    const cookieByCountry = createCookieStructure(categories, language, firstPreferenceCookie);
    setCookie({
      cookieName: COOKIE_NAME,
      cookieValue: cookieByCountry,
      cookieDomain: COOKIE_DOMAIN
    });
    const preferencesHasChanged = !import_lodash.default.isEqual(categories, currentPreferences);
    onCookieUpdate && onCookieUpdate(categories, !!saveStartedOnUseEffect, preferencesHasChanged);
  };
  useInitialCategories(forceInitialCategories, currentPreferences, saveCookie, initialCategories);
  (0, import_react7.useEffect)(() => {
    if (isValidJSON(firstPreferenceCookie)) {
      if (currentPreferences) {
        saveCookie(currentPreferences, true);
        setPreferencesCookie(currentPreferences);
      }
    }
  }, [getCookies]);
  const handleModalState = (isModalOpen2) => {
    setIsModalOpen(isModalOpen2);
  };
  const handleOnSubmit = (categories) => {
    document.dispatchEvent(new Event("@cookie-consent-manager_save-changes" /* save_changes */));
    saveCookie(categories);
    setIsModalOpen(false);
  };
  const handleGenericSubmit = (isUserAcceptAll) => {
    const categories = isUserAcceptAll ? COOKIES_ACCEPTANCE.positive : COOKIES_ACCEPTANCE.negative;
    saveCookie(categories);
    setIsModalOpen(false);
  };
  const handleDenySubmit = () => {
    document.dispatchEvent(new CustomEvent("@cookie-consent-manager_deny-all" /* deny_all */));
    handleGenericSubmit(false);
  };
  const handleAcceptSubmit = () => {
    document.dispatchEvent(new CustomEvent("@cookie-consent-manager_accept-all" /* accept_all */));
    handleGenericSubmit(true);
  };
  const handleCloseModal = () => {
    document.dispatchEvent(new CustomEvent("@cookie-consent-manager_cancel" /* cancel */));
    handleModalState(false);
  };
  const handleOpenModal = () => {
    document.dispatchEvent(new CustomEvent("@cookie-consent-manager_cookies-settings" /* cookies_settings */));
    handleModalState(true);
  };
  const DefaultActions = () => /* @__PURE__ */ import_react7.default.createElement(import_react7.default.Fragment, null, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Hide, { xxs: true, xs: true, sm: true, md: true }, /* @__PURE__ */ import_react7.default.createElement(LinkComponent, { onClick: () => handleOpenModal(), style: { textDecoration: "underline", textAlign: "left" } }, cookieBannerContent.preferences)), /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Box, { d: "flex", justifyContent: "flex-end", gap: 16 }, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Button.Outline, { small: true, onClick: () => handleDenySubmit() }, cookieBannerContent.actionButtons.denyAll), /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Button, { small: true, onClick: () => handleAcceptSubmit() }, cookieBannerContent.actionButtons.acceptAll)));
  const OptInActions = () => /* @__PURE__ */ import_react7.default.createElement(import_react7.default.Fragment, null, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Box, { d: "flex", justifyContent: "center", w: "100%", gap: 24 }, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Button.Outline, { small: true, onClick: () => handleOpenModal() }, cookieBannerContent.preferences), /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Button, { small: true, onClick: () => handleAcceptSubmit() }, cookieBannerContent.actionButtons.acceptAll)));
  return shouldRender ? /* @__PURE__ */ import_react7.default.createElement(import_yoga5.ThemeProvider, null, /* @__PURE__ */ import_react7.default.createElement(Container3, null, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Card.Header, { p: 24, pb: 16 }, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Text, { color: "deep", style: { textAlign: "left" } }, /* @__PURE__ */ import_react7.default.createElement(import_markdown_to_jsx.default, null, cookieBannerContent.title))), /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Hide, { lg: true, xl: true, xxl: true, xxxl: true }, /* @__PURE__ */ import_react7.default.createElement(import_yoga5.Card.Content, { pb: 24, px: 24 }, /* @__PURE__ */ import_react7.default.createElement(LinkComponent, { onClick: () => handleOpenModal(), style: { textDecoration: "underline", textAlign: "left" } }, cookieBannerContent.preferences))), /* @__PURE__ */ import_react7.default.createElement(Actions, null, optInLayoutVersion ? /* @__PURE__ */ import_react7.default.createElement(OptInActions, null) : /* @__PURE__ */ import_react7.default.createElement(DefaultActions, null))), /* @__PURE__ */ import_react7.default.createElement(
    CookieManager,
    {
      isModalOpen,
      handleOnClose: handleCloseModal,
      handleOnSubmit,
      handleOnDenyAll: handleDenySubmit,
      toolsList,
      preferencesCookie,
      language
    }
  )) : /* @__PURE__ */ import_react7.default.createElement(import_react7.default.Fragment, null);
}

// src/components/SegmentCookieManager/index.tsx
var import_react8 = __toESM(require("react"));

// src/utils/fetch-destinations.ts
var import_isomorphic_fetch = __toESM(require("isomorphic-fetch"));
var import_lodash2 = require("lodash");
async function fetchDestinationForWriteKey(cdnHost, writeKey) {
  const res = await (0, import_isomorphic_fetch.default)(`https://${cdnHost}/v1/projects/${writeKey}/integrations`);
  if (!res.ok) {
    throw new Error(
      `Failed to fetch integrations for write key ${writeKey}: HTTP ${res.status} ${res.statusText}`
    );
  }
  const destinations = await res.json();
  for (const destination of destinations) {
    if (destination.name === "Fullstory (Actions)") {
      destination.id = destination.name;
    } else {
      destination.id = destination.creationName;
    }
    delete destination.creationName;
  }
  return destinations;
}
async function fetchDestinations(cdnHost, writeKeys) {
  const destinationsRequests = [];
  for (const writeKey of writeKeys) {
    destinationsRequests.push(fetchDestinationForWriteKey(cdnHost, writeKey));
  }
  let destinations = (0, import_lodash2.flatten)(await Promise.all(destinationsRequests));
  destinations = destinations.filter((d) => d.id !== "Repeater");
  destinations = (0, import_lodash2.sortBy)(destinations, ["id"]);
  destinations = (0, import_lodash2.sortedUniqBy)(destinations, "id");
  return destinations;
}

// src/components/SegmentCookieManager/index.tsx
function SegmentCookieManager({
  language = "en-us",
  onUserConsentOrDeny = () => null,
  onCookieUpdate: onCategoriesUpdate = () => null,
  policyVersion = "1.0.0",
  writeKey,
  cdnHost = "cdn.segment.com",
  initialCategories,
  forceInitialCategories = false,
  optInLayoutVersion = false
}) {
  const hasRendered = (0, import_react8.useRef)(false);
  const [toolsList, setToolsList] = (0, import_react8.useState)([]);
  function populateEnabledDestinations(integrations, categories) {
    let shouldLoadSegment = false;
    for (let destionationIndex = 0; destionationIndex < toolsList.length; destionationIndex++) {
      const destination = toolsList[destionationIndex];
      if (categories[destination.category]) {
        integrations[destination.id] = true;
        shouldLoadSegment = true;
      }
    }
    return shouldLoadSegment;
  }
  const fetchToolsList = (0, import_react8.useCallback)(async () => {
    const destinations = await fetchDestinations(cdnHost, [writeKey]);
    setToolsList(normalizeTools(destinations));
  }, [cdnHost, writeKey]);
  (0, import_react8.useEffect)(() => {
    if (hasRendered.current === true)
      return;
    hasRendered.current = true;
    fetchToolsList();
  }, [fetchToolsList]);
  function onCookieUpdate(categories, saveStartedOnUseEffect, preferencesHasChanged) {
    const integrations = { "Segment.io": true };
    const shouldLoadSegment = populateEnabledDestinations(integrations, categories);
    if (preferencesHasChanged) {
      onCategoriesUpdate && onCategoriesUpdate(categories);
    }
    if (window.analytics && window.analytics.initialized) {
      if (preferencesHasChanged)
        window.location.reload();
      return;
    }
    if (shouldLoadSegment) {
      window.analytics.load(writeKey, { integrations });
    }
    if (!saveStartedOnUseEffect)
      onUserConsentOrDeny(categories);
  }
  if (!toolsList.length)
    return /* @__PURE__ */ import_react8.default.createElement(import_react8.default.Fragment, null);
  return /* @__PURE__ */ import_react8.default.createElement(
    CookieBanner,
    {
      toolsList,
      language,
      onUserConsentOrDeny,
      policyVersion,
      onCookieUpdate,
      initialCategories,
      forceInitialCategories,
      optInLayoutVersion
    }
  );
}

// src/types/cookieBanner.ts
var Language = /* @__PURE__ */ ((Language2) => {
  Language2[Language2["it-it"] = 0] = "it-it";
  Language2[Language2["es-mx"] = 1] = "es-mx";
  Language2[Language2["es-es"] = 2] = "es-es";
  Language2[Language2["es-ar"] = 3] = "es-ar";
  Language2[Language2["es-cl"] = 4] = "es-cl";
  Language2[Language2["de-de"] = 5] = "de-de";
  Language2[Language2["en-uk"] = 6] = "en-uk";
  Language2[Language2["en-us"] = 7] = "en-us";
  Language2[Language2["en-ie"] = 8] = "en-ie";
  Language2[Language2["pt-br"] = 9] = "pt-br";
  return Language2;
})(Language || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  COOKIE_TO_HANDLE_DISPLAY,
  Categories,
  CookieBanner,
  CookieManager,
  Language,
  SegmentCookieManager,
  dispatchedEvents,
  isPolicyValid,
  openCookieBanner
});
//# sourceMappingURL=index.js.map